import { render, staticRenderFns } from "./TasksSidebar.vue?vue&type=template&id=c5f14a24"
import script from "./TasksSidebar.vue?vue&type=script&lang=js"
export * from "./TasksSidebar.vue?vue&type=script&lang=js"
import style0 from "./TasksSidebar.vue?vue&type=style&index=0&id=c5f14a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports